import CloudBasedStudyStore from 'app/adapters/CloudBasedStudyStore';
import LocalStudyStore from 'app/adapters/LocalStudyStore';
import PACSStudyStoreAdataper from 'app/adapters/PACSStudyStoreAdapter';
import { WMStudyStore } from 'app/dicom/WorklistMonitor';
import { StudyStore } from 'app/interfaces/StudyStore';

export default class CombinedStudyStore implements StudyStore, WMStudyStore {
  updatePatient: StudyStore['updatePatient'];
  deleteImage: StudyStore['deleteImage'];
  getStudy: StudyStore['getStudy'];
  getStudies: StudyStore['getStudies'];
  filterStudies: StudyStore['filterStudies'];
  updateStudyMetadata: StudyStore['updateStudyMetadata'];
  updateImage: StudyStore['updateImage'];
  updateReport: StudyStore['updateReport'];
  createStudyFromWorklist: WMStudyStore['createStudyFromWorklist'];

  constructor(
    private localStudyStore: LocalStudyStore,
    private cloudStudyStore: CloudBasedStudyStore,
    private pacsStudyStoreAdapter: PACSStudyStoreAdataper
  ) {
    this.localStudyStore = localStudyStore;
    this.cloudStudyStore = cloudStudyStore;
    this.pacsStudyStoreAdapter = pacsStudyStoreAdapter;

    this.updatePatient = this.cloudStudyStore.updatePatient;
    this.deleteImage = this.cloudStudyStore.deleteImage;
    this.getStudy = this.cloudStudyStore.getStudy;
    this.getStudies = this.cloudStudyStore.getStudies;
    this.filterStudies = this.cloudStudyStore.filterStudies;
    this.updateStudyMetadata = this.cloudStudyStore.updateStudyMetadata;
    this.updateImage = this.cloudStudyStore.updateImage;
    this.updateReport = this.cloudStudyStore.updateReport;
    this.createStudyFromWorklist = async (...args) =>
      this.cloudStudyStore.createStudyFromWorklist(...args).then(() => {});
  }

  // The following methods try to save data on both local and cloud

  updateThumbnailImage: StudyStore['updateThumbnailImage'] = (...args) =>
    Promise.any([
      // this.localStudyStore.updateThumbnailImage(...args),
      this.cloudStudyStore.updateThumbnailImage(...args),
    ]);

  saveLastProcessedImage: StudyStore['saveLastProcessedImage'] = (...args) =>
    Promise.any([
      this.localStudyStore.saveLastProcessedImage(...args),
      this.cloudStudyStore.saveLastProcessedImage(...args),
    ]);

  saveRawImage: StudyStore['saveRawImage'] = (...args) =>
    Promise.any([
      this.localStudyStore.saveRawImage(...args),
      this.cloudStudyStore.saveRawImage(...args),
    ]);
  // The following methods try to retrieve data from local then fall-back to cloud

  loadImage: StudyStore['loadImage'] = async (...args) =>
    this.localStudyStore
      .loadImage(...args)
      .catch(() => (this.pacsStudyStoreAdapter.loadImage as StudyStore['loadImage'])(...args))
      .catch(() => this.cloudStudyStore.loadImage(...args));

  loadThumbnail: StudyStore['loadThumbnail'] = (...args) =>
    this.localStudyStore
      .loadThumbnail(...args)
      .catch(() => this.cloudStudyStore.loadThumbnail(...args));
}
